import React from 'react';
import { SVGComponentProps } from 'modules/core/components/layout/svg/index';

export const EyeClosedSVG: React.FC<SVGComponentProps> = ({ className }: SVGComponentProps) => (
  <svg xmlns="http://www.w3.org/2000/svg"  width="21.5" height="20.121" viewBox="0 0 21.5 20.121" className={className}>
    <g transform="translate(0.75 1.061)">
      <path d="M9.764,5.3A8.618,8.618,0,0,1,12,5c6.364,0,10,7,10,7a16.492,16.492,0,0,1-2.388,3.264M4.349,8.778A16.469,16.469,0,0,0,2,12s3.636,7,10,7a8.621,8.621,0,0,0,2.274-.306M11.5,14.958A3,3,0,0,1,9.171,13M12.5,9.041A3,3,0,0,1,14.958,11.5M3,3,21,21" transform="translate(-2 -3)"/>
    </g>
  </svg>
);